export const MainNav = [
  {
    heading: "Overview",
    items: [
      {
        icon: "pe-7s-graph",
        label: "Dashboard",
        to: "/dashboard",
      },
    ],
  },


{
  heading: "Strategy",
  items: [
    {
      icon: "pe-7s-plus",
      label: "Build Strategy",
      to: "/strategy/build",
    },
    {
      icon: "pe-7s-config",
      label: "Manage Strategies",
      to: "/strategy/manage",
    },
    {
      icon: "pe-7s-display2",
      label: "Strategy Summary",
      to: "/trading/strategy-summary",
    },
    {
      icon: "pe-7s-tools",
      label: "Rule Builder",
      to: "/rules/builder",
    },
    {
      icon: "pe-7s-albums",
      label: "Rule Templates",
      to: "/rules/templates",
    },
  ],
},

  {
    heading: "Trading",
    items: [
      {
        icon: "pe-7s-bell",
        label: "Price Alerts",
        to: "/alerts/price",
      },
      {
        icon: "pe-7s-graph2",
        label: "Positions",
        to: "/trading/positions",
      },
      {
        icon: "pe-7s-news-paper",
        label: "Order History",
        to: "/trading/orders",
      },
      {
        icon: "pe-7s-cash",
        label: "P&L Summary",
        to: "/trading/pnl",
      },
      {
        icon: "pe-7s-check",
        label: "Reconciliation",
        to: "/trading/reconciliation",
      },
    ],
  },

  {
    heading: "Automation",
    items: [
      {
        icon: "pe-7s-light",
        label: "Trade Suggestions",
        to: "/automation/suggestions",
      },
      {
        icon: "pe-7s-note2",
        label: "Order Queue",
        to: "/automation/orders",
      },
      {
        icon: "pe-7s-refresh-2",
        label: "Execution History",
        to: "/automation/history",
      },
    ],
  },

  {
    heading: "Support",
    items: [
      {
        icon: "pe-7s-help1",
        label: "Help & Tutorials",
        to: "/chat",
      },
    ],
  },

  {
    heading: "Admin",
    adminOnly: true,
    items: [
      {
        icon: "pe-7s-users",
        label: "User Management",
        to: "/admin/users",
      },
      {
        icon: "pe-7s-comment",
        label: "Support Sessions",
        to: "/admin/chat",
      },
      {
        icon: "pe-7s-server",
        label: "System Health",
        to: "/admin/system/health",
        superAdminOnly: true,
      },
    ],
  },

  {
    heading: "Profile",
    items: [
      {
        icon: "pe-7s-user",
        label: "User Profile",
        to: "/profile",
      },
      {
        icon: "pe-7s-bell",
        label: "Notifications",
        to: "/profile/notifications",
      },
      {
        icon: "pe-7s-config",
        label: "System Settings",
        to: "/system/settings",
      },
    ],
  },
];
